export const REQUEST_SAVE_DRAFT = "REQUEST_SAVE_DRAFT";
export const INVALID_SAVE_DRAFT = "INVALID_SAVE_DRAFT";
export const SAVED_DRAFT = "SAVED_DRAFT";
export const FAILED_TO_SAVE_DRAFT = "FAILED_TO_SAVE_DRAFT";
export const REQUEST_LOAD_DRAFT = "REQUEST_LOAD_DRAFT";
export const INVALID_LOAD_DRAFT = "INVALID_LOAD_DRAFT";
export const RECEIVE_DRAFT = "RECEIVE_DRAFT";
